module.exports = __webpack_public_path__ + "static/img/包裝第二組組長-王煦妍.2ca1d06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/包裝第二組組長-王煦妍.jpg
// module id = NG+0
// module chunks = 1